<template>
  <!-- One tag for a pack wherever a product is listed, so the table and the command center cannot drift. -->
  <TwnTag
    icon="package"
    severity="info"
    value="Pack"
  />
</template>

<script lang="ts" setup>
import TwnTag from '@/components/atoms/prime/tag/twn-tag/TwnTag.vue'
</script>
